





































































































    import { Vue, Component, Prop } from "vue-property-decorator";
    import { JobOffer } from "../../_models/jobOffer";
    import "@toast-ui/editor/dist/toastui-editor-viewer.css";
    import { Viewer } from "@toast-ui/vue-editor";
    import { userUtils } from "../../_utils/userUtils";

    @Component({
        components: {
            Viewer
        }
    })
    export default class DetailsJobOffer extends Vue {
        @Prop() info!: JobOffer;

        private viewerText: string;
        private showContacts: boolean;
        private tipoSoggetto: number;
        
        constructor() {
            super();
            this.viewerText = this.info.competenze;
            this.showContacts = false;
            this.tipoSoggetto = 0;
        }

        mounted() {
            const token = localStorage.getItem("userToken");
            if (token) {
                const parsedToken: any = userUtils.parseToken(token);
                this.tipoSoggetto = parsedToken.IdTipoSoggetto || 0;
            }
        }

        get canViewVisibility(): boolean {
            return this.tipoSoggetto === 2 || this.tipoSoggetto === 3;
        }
}
